// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getLanguageById } from 'app/constants/enums/Language/main';

/* eslint-disable max-len */
export const EN = getLanguageById('en');
export const ES = getLanguageById('es');
export const ID = getLanguageById('id');
export const IT = getLanguageById('it');
export const JA = getLanguageById('ja');
export const KO = getLanguageById('ko');
export const PT_BR = getLanguageById('pt-BR');
export const RU = getLanguageById('ru');
export const TH = getLanguageById('th');
export const TLH = getLanguageById('tlh');
export const TR = getLanguageById('tr');
export const VI = getLanguageById('vi');
export const ZH_HANS = getLanguageById('zh-Hans');
export const ZH_HANT = getLanguageById('zh-Hant');
/* eslint-enable max-len */
